/* eslint-disable ember/no-computed-properties-in-native-classes, ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { service } from '@ember/service';
import config from 'linced-app/config/environment';
import { alias } from '@ember/object/computed';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import PersonType from '@linc-technologies/linced-common/enums/person-type';

export default class AttendanceTrackerRoute extends Route {
  queryParams = {
    year: {
      refreshModel: true,
    },
  };

  // Attrs
  Jurisdiction = Jurisdiction;

  @alias('session.school.jurisdiction')
  jurisdiction;

  // Services
  @service
  dates;

  @service
  fetch;

  @service
  session;

  @service
  store;

  model(params) {
    let year = params.year || moment().format('YYYY');
    let trackerUrl = `${config.APP.apiHost}/attendance/${config.APP.apiPath}/tracker?schoolId=${this.session.activeSchool}&academicYear=${year}&jurisdiction=${this.jurisdiction}`;
    let data = {
      people: this.store.query('person', {
        type: PersonType.LEARNER,
        includeFormer: true,
      }),
      tracker: this.fetch.request(trackerUrl),
      terms: this.store.findAll('term'),
      year,
    };
    return hash(data);
  }

  setupController(controller) {
    super.setupController(...arguments);
    controller.initAttendanceFilters();
  }

  deactivate() {
    super.deactivate(...arguments);
    this.controller.reset();
  }
}
